import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService } from '../../../../tms-shared';
import { TmsWebBaseEditService } from '../../base';
import { Printers } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class PrinterService extends TmsWebBaseEditService<Printers, Printers> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('Printer', $localize`Printers`, httpService, notificationService);
  }
  getDocument(documentName: string): Observable<Printers> {
    return this.httpService.get<Printers>(`${this.apiUrl}/GetDocument?documentName=${documentName}`);
  }

  getAllExternalDocuments(): Observable<Printers[]> {
    return this.httpService.get<Printers[]>(`${this.apiUrl}/GetAllExternalDocuments`);
  }
}
